import { get } from './api/http.service';
/**
 * Get record download
 */
export const getRecordDownload = (params) => {
  return get('/ccs/v1/media/record/download', params);
};

/**
 * Get record download list
 */
export const getRecordDownloadList = (params) => {
  return get('/ccs/v1/media/record/download/list', params);
};
